<template>
  <div
    class="tw-relative"
    :style="{ backgroundImage: `url(${cta.background_image})` }"
  >
    <div class="tw-bg-black tw-bg-opacity-[.35] tw-absolute tw-inset-0"></div>
    <div
      class="tw-p-8 tw-text-center tw-flex tw-items-center tw-justify-center tw-relative tw-z-10"
    >
      <div>
        <h2 class="text-3xl shadow text-white">
          {{ cta.heading }}
        </h2>
        <div>{{ cta.content }}</div>
        <div>
          <div v-if="cta.link_type === 'media'">
            <a
              class="jwb-button shadow"
              aria-label="Links to a pdf"
              :href="cta.media_upload.url"
              target="_blank"
              >{{ cta.link_text }}
            </a>
          </div>

          <div v-if="cta.link_type === 'internal'">
            <a class="jwb-button shadow" :href="cta.internal_link">
              {{ cta.link_text }}
            </a>
          </div>

          <div v-if="cta.link_type === 'external'">
            <a
              class="jwb-button shadow"
              href="cta.external_link"
              target="_blank"
              >{{ cta.link_text }}
            </a>
          </div>

          <button
            v-if="cta.link_type === 'video'"
            class="jwb-button shadow"
            @click.prevent="modal.open = true"
          >
            {{ cta.link_text }}
          </button>

          <a
            v-if="cta.link_type === 'event'"
            class="jwb-button shadow"
            href="/calendar"
            >{{ cta.link_text }}
          </a>
        </div>
      </div>
    </div>

    <TransitionModal>
      <div
        v-if="modal.open"
        class="tw-fixed tw-inset-0 tw-z-[2000] tw-flex tw-items-center tw-justify-center tw-px-4"
      >
        <div
          class="tw-fixed tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75"
          @click="modal.open = false"
        ></div>

        <div
          class="tw-bg-white tw-relative tw-z-10 tw-p-12 tw-rounded-md tw-modal tw-w-full tw-max-w-2xl"
        >
          <div
            class="tw-right-0 tw-top-0 tw-mr-4 tw-mt-4 tw-absolute tw-cursor-pointer"
            @click="modal.open = false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="tw-h-5 tw-w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <div v-html="cta.video_embed"></div>
        </div>
      </div>
    </TransitionModal>
  </div>
</template>

<script>
import TransitionModal from '~/components/TransitionModal.vue'

export default {
  props: {
    cta: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  components: {
    TransitionModal,
  },
  data() {
    return {
      modal: {
        open: false,
      },
    }
  },
}
</script>
